export default {
	"address.TheShippingAddressCannotBeEmpty": "收貨位址不能為空！",
	"address.NameIsNotLegal": "姓名不合法",
	"address.EnterTheMobilePhoneNumberAreaCode": "輸選擇手機號區域號",
	"address.EnterTheCorrectPhoneNumber": "輸入正確手機號",
	"address.PleaseSelectARegion": "請選擇地區",
	"address.AddressesCannotContainIllegalCharacters": "位址不能包含非法字元",
	"address.PleaseEnterTheCertificateNumberCorrectly": "請正確輸入證件號",
	"address.MyAddressPageDefaultAddressSwitch": "我的位址頁_預設位址開關",
	"address.MyAddressPageSaveAndUse": "我的位址頁_保存並使用",
	"address.TheOperationFailed": "操作失敗了",
	"address.OperationSuccessful": "操作成功！",
	"address.ParameterError": "參數錯誤",
	"address.MyAddressPageDeleteAddress": "我的位址頁_刪除位址",
	"address.DeleteFailed": "刪除失敗了",
	"address.PleaseEnterTheConsigneeName": "請輸入收貨人姓名",
	"address.TheNameOfTheConsigneeShallNotExceed20Characters": "收貨人姓名不超過20字",
	"address.TheNameOfTheConsignee": "收貨人姓名",
	"address.name": "姓名",
	"address.PleaseEnterYourPhoneNumber": "請輸入手機號",
	"address.ContactNumber": "聯繫電話",
	"address.SelectAStateOrMunicipality": "選擇省市自治區",
	"address.Region": "所在地區",
	"address.TheTypeOfCredential": "證件類型",
	"address.PleaseEnterTheIdNumber": "請輸入證件號",
	"address.DetailedAddress": "詳細位址",
	"address.SuchAsTheCommunityBuildingNumberHouseNumberEtc": "如社區、樓棟號、門牌號等...",
	"address.PleaseEnterYourFullAddress": "請輸入詳細位址",
	"address.StreetDoorNumbersDoNotExceed100Words": "街道門牌不超過100字",
	"address.SetToTheDefaultAddress": "設為預設位址",
	"address.SetToDefaultAddressNextTimeAfterDefaultingToUseTheAddress": "設為預設位址後下次預設使用該位址",
	"address.DeleteAnAddress": "刪除位址",
	"address.SaveAndUse": "保存並使用"
}